<template>
  <div class="btn-group">
    <button
      v-for="val in values"
      :key="val"
      type="button"
      :class="[
        'btn',
        { 'btn-primary': value === val, 'btn-default': value !== val }
      ]"
      @click="changeSelectVal(val)"
    >
      {{ val }}
    </button>
  </div>
</template>

<script>
export default {
  props: ["values", "value"],
  methods: {
    changeSelectVal(val) {
      this.$emit("input", val)
    }
  }
}
</script>
